import React from 'react';
import PropTypes from 'prop-types';

import Throbber from 'components/Throbber';

/**
 * Throbber wrapped in a button for displaying background task on click.
 * @param {Object} props Props of the component.
 * @return {React.Component} button with wrapped children or Thorbber if pending.
 */
const ThrobberButton = ({ pending, onClick, children, ...buttonProps }) => (
    <button {...buttonProps} type="button" onClick={(e) => (pending ? null : onClick(e))}>
        {pending ? <Throbber white small /> : children}
    </button>
);

ThrobberButton.displayName = 'ThrobberButton';

ThrobberButton.propTypes = {
    pending: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ThrobberButton.defaultProps = {
    pending: false,
    children: '',
};

export default ThrobberButton;
